import React, {useCallback, useEffect, useState} from "react";
import Back from "assets/images/svg/back_blue.svg";
import {useNavigate, useSearchParams} from "react-router-dom";
import Versions from "assets/images/svg/versions_dark2.svg";
import Input from "components/input-fields/input-fields";

import {useModal} from "hooks";
import FawrySummary from "./component/fawrySummary";
import PaymentApproved from "./component/paymentApproved";
import PaymentFailed from "./component/paymentFailed";
import {useQuery} from "react-query";
import _paymentService, {DiscriminatorVal} from "services/payment-services";
import {json, showDiscriminate} from "helpers/data";
import {usePayMethods} from "hooks/use-pay-method";
import PaymentForm from "./component/payForm";
import {Button, Form} from "components/form";
import PreviewImage from "components/preview-img";
import _ from "lodash";
import UnpaidInvoice from "./component/unpaidInvoice";
import {useTranslation} from "react-i18next";
import {handleRefreshToken} from "helpers/client";

const PaymentDetails = () => {
    const {t} = useTranslation("browse-apps");

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showFawryCard, openFawryCard, fawryClose, closeFawryWithRoute] = useModal(false);
    const [showPaymentApproved, openPaymentApproved, paypalClose, closePaypalWithRoute] = useModal(false);
    const [showPaymentFail, openPaymentFail, closePaymentFail] = useModal(false);
    const [showUnPaidInvoice, openUnPaidInvoice, closeUnPaidInvoice] = useModal(false);
    const [referenceNumber, setReferenceNumber] = useState();
    const [expirationDate, setExpirationDate] = useState();

    const VersionId = searchParams.get("VersionId");
    const InvoiceId = searchParams.get("invoiceId");
    const PriceLevelId = searchParams.get("PriceLevelId");
    const Discriminate = searchParams.get("Discriminate");
    const AddOn = searchParams.get("addOnId");
    const VersionSubscriptionId = searchParams.get("VersionSubscriptionId");
    const versionReleaseId = searchParams.get("versionReleaseId");
    const paymentCountryId = searchParams.get("paymentCountryId");


    const token = searchParams.get("token");
    const payerId = searchParams.get("PayerID") || "";
    const signature = searchParams.get("signature");

    const [bill, setBill] = useState(Discriminate);
    const {payMethods} = usePayMethods();
    const {data: appPayDetails, isSuccess} = useQuery(["app-payDetails", bill], () => {
        if (InvoiceId) {
            return _paymentService.getInvoice_payDetails(InvoiceId).then((r) => r.response);
        }
        return _paymentService
            .getApp_payDetails(VersionId, PriceLevelId, DiscriminatorVal[bill], AddOn, versionReleaseId, VersionSubscriptionId, paymentCountryId)
            .then((r) => r.response);
    });
    const finishPay = useCallback(() => {
        _paymentService.do_pay(token, payerId).then(() => {
            openPaymentApproved();
            handleRefreshToken();
        });
    }, [openPaymentApproved, payerId, token]);

    const finishPayFawryCard = useCallback(() => {
        const type = searchParams.get("type");
        const referenceNumber = searchParams.get("referenceNumber");
        const merchantRefNumber = searchParams.get("merchantRefNumber");
        const orderAmount = searchParams.get("orderAmount");
        const fawryFees = searchParams.get("fawryFees");
        const orderStatus = searchParams.get("orderStatus");
        const paymentMethod = searchParams.get("paymentMethod");
        const paymentTime = searchParams.get("paymentTime");
        const customerMobile = searchParams.get("customerMobile");
        const customerMail = searchParams.get("customerMail");
        const customerProfileId = searchParams.get("customerProfileId");
        const taxes = searchParams.get("taxes");
        const statusCode = searchParams.get("statusCode");
        const statusDescription = searchParams.get("statusDescription");
        const basketPayment = searchParams.get("basketPayment");

        let param = {
            type: type,
            referenceNumber: referenceNumber,
            merchantRefNumber: merchantRefNumber,
            orderAmount: orderAmount,
            fawryFees: fawryFees,
            orderStatus: orderStatus,
            paymentMethod: paymentMethod,
            paymentTime: paymentTime,
            customerMobile: customerMobile,
            customerMail: customerMail,
            customerProfileId: customerProfileId,
            signature: signature,
            taxes: taxes,
            statusCode: statusCode,
            statusDescription: statusDescription,
            basketPayment
        };
        _paymentService.do_Pay_fawry(param).then(() => {
            openPaymentApproved();
        });
    }, [openPaymentApproved, searchParams, signature]);


    useEffect(() => {
        if (payerId && token) {
            finishPay();
        } else if (signature) {
            setLoading(true);
            finishPayFawryCard();
        } else if (token) {
            let finalData = JSON.parse(localStorage.getItem("appPayDetails"));
            _paymentService
                .payByFawryCard({
                    ...finalData,
                    successCallBackUrl: window.location.href,
                    versionSubscriptionId: VersionSubscriptionId,
                    failCallBackUrl: window.location.href,
                    returnUrl: window.location.href,
                    isFawryCard: true,
                    cardToken: token
                })
                .then(({response}) => {
                    let fawry = JSON.parse(response.paymentInfo).Fawry;
                    window.location.href = fawry?.ThreeDSecureUrl;
                });
        }
    }, [finishPay, finishPayFawryCard, payerId, signature, token]);

    const handlePay = (data) => {
        let finalData = {
            ...appPayDetails,
            currencyName: json(appPayDetails?.currencyName, "en"),
            paymentMethodId: data?.paymentMethodId,
            successCallBackUrl: window.location.href,
            failCallBackUrl: window.location.href,
            returnUrl: window.location.href
        };
        setLoading(true);
        localStorage.setItem("appPayDetails", JSON.stringify(appPayDetails));

        if (data?.fawryWay === "card") {
            if (data?.card_id !== "add") {
                _paymentService
                    .payByFawryCard({
                        ...finalData,
                        successCallBackUrl: window.location.href,
                        failCallBackUrl: window.location.href,
                        returnUrl: window.location.href,
                        isFawryCard: true,
                        cardToken: data?.card_id
                    })
                    .then(({response}) => {
                        let fawry = JSON.parse(response.paymentInfo).Fawry;
                        window.location.href = fawry?.ThreeDSecureUrl;
                    }).finally(() => {
                    setLoading(false);
                });
            } else {
            }
        } else {
            _paymentService
                .send_payDatails(finalData)
                .then(({response}) => {
                    let IsSuccess = JSON.parse(response.paymentInfo).IsSuccess;
                    let paypal = JSON.parse(response.paymentInfo).Paypal;
                    let fawry = JSON.parse(response.paymentInfo).Fawry;
                    let Bank = JSON.parse(response.paymentInfo).Bank;
                    if (!_.isEmpty(paypal)) {
                        window.location.href = paypal?.ApproveOrderLink;
                    } else if (!_.isEmpty(fawry)) {
                        if (IsSuccess) {
                            openFawryCard();
                            setReferenceNumber(fawry?.ReferenceNumber);
                            setExpirationDate(fawry?.Expiration);
                        } else {
                            openUnPaidInvoice();
                        }
                    } else if (!_.isEmpty(Bank)) {
                        let x = Bank?.Parameters.reduce(function (obj, v) {
                            let val = v.split("=");
                            let keyVal = val[0];
                            let vall = val[1];
                            obj[keyVal] = vall;
                            return obj;
                        }, {});

                        var form = document.createElement("form");
                        Object.values(x).forEach((element, i) => {
                            var inputs = document.createElement("input");
                            if (Object.keys(x)[i] !== "action") {
                                inputs.setAttribute("type", "hidden");
                                inputs.setAttribute("name", Object.keys(x)[i]);
                                inputs.setAttribute("value", element);
                                form.appendChild(inputs);
                            }
                        });

                        form.method = "post";
                        form.action = x["action"];
                        document.body.appendChild(form);
                        form.submit();
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <div className="payment-details">
            <div className="header">
                <Button className="btn-back" onClick={() => navigate(-1)}>
                    <img className="back" src={Back} alt="back"/>
                </Button>
                <h1 className="title"> {t("paymentDetails.mainTitle")}</h1>
            </div>
            <hr className="hr"/>
            <div className="row">
                <div className="col-xl-5 col-lg-8 col-md-12">
                    <div className="box-payment">
                        <div className="header">
                            <div className="info">
                                {isSuccess && <PreviewImage src={appPayDetails?.image?.fullPath} className="logo"/>}
                                <div>
                                    <h2 className="title">{json(appPayDetails?.title)}</h2>
                                    <h3 className="versions">
                                        {" "}
                                        <img src={Versions} alt={Versions}/>
                                        {json(appPayDetails?.versionTitle)}
                                    </h3>
                                </div>
                            </div>

                            <div className="choose">
                                <Input
                                    type="select"
                                    label={`${json(appPayDetails?.priceLevelName)} (${appPayDetails?.numberOfLicenses} ${t(
                                        "paymentDetails.summary.users"
                                    )})`}
                                    readonly
                                />
                            </div>
                        </div>
                        <div className="bill">
                            <Form onSubmit={handlePay}>
                                {isSuccess && (
                                    <PaymentForm
                                        data={payMethods}
                                        appPayDetails={appPayDetails}
                                        onBill={setBill}
                                        defaultBill={bill}
                                        isLoading={loading}
                                        InvoiceId={InvoiceId}
                                    />
                                )}
                            </Form>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-12">
                    <div className="box-summary">
                        <h1 className="title">{t("paymentDetails.summary.mainTitle")}</h1>
                        <p className="info">{json(appPayDetails?.title)}</p>
                        <p className="info">
                            {json(appPayDetails?.priceLevelName)} ({appPayDetails?.numberOfLicenses} {t("paymentDetails.summary.users")})
                        </p>
                        <p className="info">
                            {t("paymentDetails.summary.bill")} {json(`${showDiscriminate(`${bill}`)}`)}
                        </p>
                        <div className="details">
                            <span className="name">{t("paymentDetails.summary.price")}</span>
                            <span className="number">
                {appPayDetails?.price} <span>{json(appPayDetails?.currencyName)}</span>
              </span>
                        </div>
                        <div className="details">
                            <span className="name discount">{t("paymentDetails.summary.discount")}</span>
                            <span className="number discount">
                {appPayDetails?.totalDiscountAmount} <span>{json(appPayDetails?.currencyName)}</span>
              </span>
                        </div>
                        <div className="details">
                            <span className="name ">{t("paymentDetails.summary.netPrice")}</span>
                            <span className="number">
                {appPayDetails?.subTotal} <span>{json(appPayDetails?.currencyName)}</span>
              </span>
                        </div>

                        <div className="details">
              <span className="name">
                {t("paymentDetails.summary.vat")} {appPayDetails?.vatPercentage}%
              </span>
                            <span className="number">
                {appPayDetails?.totalVatAmount} <span>{json(appPayDetails?.currencyName)}</span>
              </span>
                        </div>

                        <div className="details">
                            <span className="name total">{t("paymentDetails.summary.total")}</span>
                            <span className="number total">
                {appPayDetails?.total} <span>{json(appPayDetails?.currencyName)}</span>
              </span>
                        </div>
                    </div>
                </div>
            </div>
            <FawrySummary
                show={showFawryCard}
                onHide={() => closeFawryWithRoute("/my-products")}
                data={appPayDetails}
                number={referenceNumber}
                expire={expirationDate}
            />
            <PaymentApproved show={showPaymentApproved} onHide={() => closePaypalWithRoute("/my-products")}
                             data={appPayDetails}/>
            <PaymentFailed show={showPaymentFail} onHide={closePaymentFail}/>
            <UnpaidInvoice show={showUnPaidInvoice} onHide={() => closePaypalWithRoute("/invoices/unpaid")}/>
        </div>
    );
};

export default PaymentDetails;
